import {createSlice} from '@reduxjs/toolkit';
import {
  ADMIN_USERS,
  NORMAL_USERS,
  TABLE_DISPLAY_MODE_ACTIONS,
  TABLE_DISPLAY_MODE_FEATURES
} from "../../pages/user/constants";
import {setPaginatedItems} from "../../helpers/helperFunctions";

const initialState = {

  [ADMIN_USERS]: {
    meta: {
      page: 1,
      totalPages: -1
    },
    pageData: {}
  },
  [NORMAL_USERS]: {
    meta: {
      page: 1,
      totalPages: -1
    },
    pageData: {}

  },
  selectedTab: NORMAL_USERS,
  displayMode: TABLE_DISPLAY_MODE_FEATURES,
  template: {
    loading: false,
    error: '',
    data: [],
    init: false
  },
  modals: {
    form: {},
    confirm: {},
    feature: {},
    password: {}
  },
  features: {
    loading: false,
    error: '',
    data: [],
    init: false
  }
};

const manageUserSlice = createSlice({
  name: 'manageUser',
  initialState: initialState,
  reducers: {
    getBookedShifts: () => {
    },
    tryLoadUsers: () => {
    },
    tryChangeUsersPassword: () => {
    },
    tryUpdateUsersState: () => {
    },
    tryAddOrUpdateUsers: () => {
    },
    tryUpdateUserFeatures: () => {
    },
    setUsers: (state, action) => setPaginatedItems(state, action),
    setManageUserModals: (state, action) => {
      if (action.payload?.modal) {
        const type = action.payload.isConfirm ? 'confirm' : action.payload.isFeatureAdd ? 'feature' : action.payload.isPassword ? 'password' : 'form';
        state.modals[type].data = action.payload.data;
        state.modals[type].modal = action.payload.modal;
        state.modals[type].ext = action.payload.ext;
      } else {
        state.modals = {...initialState.modals};
      }
    },
    setCurrentPage: (state, action) => {
      state[state.selectedTab].meta.page = action.payload.page;
    },
    setAdminFeatures: (state, action) => {
      state.features.data = action.payload.features;
      state.features.init = true;
    },
    setSelectedTab: (state, action) => {
      state.selectedTab = action.payload?.tab ? action.payload.tab : (state.selectedTab === NORMAL_USERS ? ADMIN_USERS : NORMAL_USERS);
    },
    setAdminsTableMode: (state, action) => {
      state.displayMode = action.payload?.mode ? action.payload.mode : (state.displayMode === TABLE_DISPLAY_MODE_FEATURES ? TABLE_DISPLAY_MODE_ACTIONS : TABLE_DISPLAY_MODE_FEATURES);
    },
    updateUserData: (state, action) => {
      const sel = state.selectedTab;
      const currentPage = state[sel].meta.page;

      state[sel].pageData[currentPage].data = state[sel].pageData[currentPage].data.map((user) => user.id === action.payload.user.id ? action.payload.user : user);
    },
    resetUsers: (state) => {
      state[state.selectedTab] = {...initialState[NORMAL_USERS]};
    },
    resetManageUsers: (state) => initialState

  }
});

export const {
  tryLoadUsers,
  setUsers,
  setManageUserModals,
  tryAddOrUpdateUsers,
  setCurrentPage,
  resetUsers,
  resetManageUsers,
  updateUserData,
  setSelectedTab,
  setAdminFeatures,
  setAdminsTableMode,
  tryUpdateUsersState,
  tryUpdateUserFeatures,
  tryChangeUsersPassword

} = manageUserSlice.actions;

export default manageUserSlice.reducer;
